/**
 * Google Ads API Service
 * 
 * Reemplazado por @boosting/integrations desde el monorepo.
 * Mantiene compatibilidad con la API existente en Appmor.
 */

import { createGoogleAdsService, GoogleAdsService } from '@boosting/integrations';
import { credentialsService } from '../credentials.service';
import { db } from '@/core/config/firebase';

// Adaptador para asegurar compatibilidad de tipos con CredentialsProvider
const credentialsAdapter = {
  getValue: (key: string) => credentialsService.getValue(key),
  setValue: (key: string, value: string, options?: any) => credentialsService.setValue(key, value, options)
};

// Inicializar servicio compartido
// Casting db as any because firebase-admin types might differ slightly from the interface but are runtime compatible
export const googleAdsService = createGoogleAdsService(credentialsAdapter, db as any);

// Exportar tipos y clases para compatibilidad
export type { GoogleAdsService } from '@boosting/integrations';

// Export specific types to avoid conflicts with other modules (like PhantomBuster/LinkedIn)
export type {
  GoogleAdsCredentials,
  KeywordPlanRequest,
  KeywordPlanResponse,
  CampaignInfo,
  GoogleAdsConfig
} from '@boosting/integrations';

// Re-define local types if they are missing in shared but used in app
export interface AdGroupInfo {
  id: string;
  campaignId: string;
  name: string;
  status: 'ENABLED' | 'PAUSED' | 'REMOVED';
  cpcBidMicros?: number;
}


export default googleAdsService;






